import axios from "../../axios.js";
import { createRequestSequence } from "../requestSequence";

// Sekwencja żądań listy zamówień. Tylko odpowiedź z NAJNOWSZEGO żądania może
// nadpisać store. Zapobiega wyścigowi: wolne żądanie (np. ALL po wejściu na widok)
// wracające PO szybszym (świeżo wybrany status) nie nadpisuje już wybranego statusu.
let latestOrdersWithStatusRequestId = 0;
const employeeOrdersSeq = createRequestSequence();
const customerOrdersSeq = createRequestSequence();

const getOrdersWithStatus = async ({ commit }, data) => {
  // Tworzymy obiekt params
  const params = {};
  if (data.filter_param) {
    if (data.filter_param === "REJECTED_AUTOMATICALLY") {
      params.status = "REJECTED";
      params.automatically_finished = true;
    } else if (data.filter_param === "FINISHED_IN_LESS_THAN_AN_HOUR") {
      params.status = "FINISHED";
      params.finished_in_less_than_an_hour = true;
    } else {
      params.status = data.filter_param;
    }
  }

  if (data.search_param) {
    params.filter_param = data.search_param;
  }

  if (data.on_page) {
    params.on_page = data.on_page;
  }

  if (data.page_number) {
    params.page_number = data.page_number;
  }

  if (data.date_from) {
    params.date_from = data.date_from;
  }

  if (data.date_to) {
    params.date_to = data.date_to;
  }

  // Po którym polu daty filtrujemy zakres: CREATION (data utworzenia) lub REALIZATION (termin wykonania).
  if (data.date_field) {
    params.date_field = data.date_field;
  }

  const requestId = ++latestOrdersWithStatusRequestId;

  try {
    commit("GET_ORDERS_WITH_STATUS_PENDING");
    const res = await axios.get("api/order/withStatus", { params });
    // W międzyczasie wystartowało nowsze żądanie (zmiana statusu) — porzuć tę odpowiedź.
    if (requestId !== latestOrdersWithStatusRequestId) return;
    commit("GET_ORDERS_WITH_STATUS_SUCCESS", res.data);
  } catch (error) {
    // Błąd starszego, nieaktualnego żądania nie może czyścić świeżo załadowanej listy.
    if (requestId !== latestOrdersWithStatusRequestId) return;
    commit("GET_ORDERS_WITH_STATUS_FAIL");
  }
};

const fetchAllEmployeeOrders = ({ commit }, data) => {
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const filterParam = data.filter_param;
  const url = `api/order/employee/${filterParam}?${on_page}${page_number}`;

  const requestId = employeeOrdersSeq.next();
  axios
    .get(url)
    .then((response) => {
      if (!employeeOrdersSeq.isLatest(requestId)) return;
      commit("SET_EMPLOYEE_ORDERS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchAllCustomerOrders = ({ commit }, data) => {
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const filterParam = data.filter_param;
  const secondFilterParam = data.second_filter_param;
  const url = `api/order/customer/${filterParam}?for_who=${secondFilterParam}&${on_page}${page_number}`;

  const requestId = customerOrdersSeq.next();
  axios
    .get(url)
    .then((response) => {
      if (!customerOrdersSeq.isLatest(requestId)) return;
      commit("SET_CUSTOMER_ORDERS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchOrdersWithoutEmployee = ({ commit }, data) => {
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const url = `api/orderWithoutEmployee?${on_page}${page_number} `;
  axios
    .get(url)
    .then((response) => {
      commit("SET_ORDERS_WITHOUT_EMPLOYEE", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const downloadOrdersHistoryXls = async ({ commit }, data) => {
  let status = data.filter ? `status=${data.filter}&` : "";
  let automatically_finished = false;
  let finished_in_less_than_an_hour = false;
  const search_param = data.searchParam
    ? `filter_param=${data.searchParam}&`
    : "";
  // Klucze dat przychodzą z TableHeader.downloadTableData w camelCase (reszta payloadu też).
  const date_from = data.dateFrom ? `date_from=${data.dateFrom}&` : "";
  const date_to = data.dateTo ? `date_to=${data.dateTo}&` : "";
  const date_field = data.dateField ? `date_field=${data.dateField}&` : "";
  if (status && data.filter === "REJECTED_AUTOMATICALLY") {
    status = `status=REJECTED&`;
    automatically_finished = true;
  }
  if (status && data.filter_param === "FINISHED_IN_LESS_THAN_AN_HOUR") {
    status = `status=FINISHED&`;
    finished_in_less_than_an_hour = true;
  }
  const url = `api/order/withStatus?download=true&${status}${search_param}${date_from}${date_to}${date_field}automatically_finished=${automatically_finished}&finished_in_less_than_an_hour=${finished_in_less_than_an_hour}&`;

  axios(url, {
    method: "GET",
    headers: {
      "Content-Disposition": "attachment; filename=zamowienia.xls",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "blob",
  })
    .then((response) => {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", "zamowienia.xls");
      document.body.appendChild(fileLink);

      fileLink.click();
      commit("SET_DOWNLOAD_MESSAGE", "OK");
    })
    .catch((err) => console.log(err.response));
};

const downloadNotFoundOrdersHistoryXls = async ({ commit }) => {
  const url = `api/orderWithoutEmployee/file`;
  axios(url, {
    method: "GET",
    headers: {
      "Content-Disposition":
        "attachment; filename=zamowienia_dla_ktorych_nie_znaleziono_opiekuna.xls",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    responseType: "blob",
  })
    .then((response) => {
      const fileURL = window.URL.createObjectURL(new Blob([response.data]));
      const fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        "zamowienia_dla_ktorych_nie_znaleziono_opiekuna.xls"
      );
      document.body.appendChild(fileLink);

      fileLink.click();
      commit("SET_DOWNLOAD_MESSAGE", "OK");
    })
    .catch((err) => console.log(err.response));
};

const createAutoPlannedChangeForOrder = async ({ commit }, data) => {
  const url = `api/plannedAutoChanges`;
  const response = await axios.post(url, data);
  commit("SET_DOWNLOAD_MESSAGE", "OK");
  return response.data;
};

export default {
  downloadNotFoundOrdersHistoryXls,
  downloadOrdersHistoryXls,
  getOrdersWithStatus,
  fetchAllEmployeeOrders,
  fetchAllCustomerOrders,
  fetchOrdersWithoutEmployee,
  createAutoPlannedChangeForOrder,
};
